// extracted by mini-css-extract-plugin
export var black = "_2a-6";
export var brand = "_2a-1";
export var ddefault = "_2a-0";
export var error = "_2a-3";
export var gray = "_2a-2";
export var highContrast = "_2a-8";
export var outline = "_2a-7";
export var success = "_2a-5";
export var warning = "_2a-4";